import React from 'react';
import { View, Link, Icon, colors } from '@fairygodboss/ui';
import { StyledModerationMenu } from './ModerationMenu';

const FoldLink = ({ communityContext }) => {
    const { seeMoreLink, contentType } = communityContext();

    let linkText = 'ARTICLES & ADVICE';
    if (contentType === 'podcasts') {
        linkText = 'PODCASTS';
    }
    if (contentType === 'community') {
        linkText = 'DISCUSSIONS';

    }
    return (
        <View
            css={{
                'a:visited': {
                    color: `${colors.primary[60]} !important`,
                    'div > svg': {
                        path: {
                            fill: colors.primary[60],
                        },
                    },
                    'a:hover': {
                        // color: `${colors.primary[80]} !important`,
                        'div > svg': {
                            path: {
                                fill: colors.primary[80],
                            },
                        },
                    },
                },
                a: {
                    textDecoration: 'none',
                    fontSize: '16px',
                    lineHeight: '20px',
                    fontWeight: '600',
                },
                svg: {
                    height: '14px',
                },
            }}
        >
            <Link href={seeMoreLink} target="_self" variant="inline">
                <Icon height="14px" variant="chevron_left_16" />
                {linkText}
            </Link>
        </View>
    );
};

export const AboveTheFoldLink = ({ communityContext }) => {
    const { hash, type, deleted, contentType, onHandleDelete, handleOnEditClick} = communityContext();
    const canDelete = (contentType === 'community')
    return (
        <View
            display="flex"
            justifyContent="space-between"
            pt={{ _: '32px', sm: '32px', md: '56px' }}
            pb={{ _: '24px', sm: '34px' }}
        >
            <FoldLink communityContext={communityContext} />
            {!deleted ? (
                <>
                    <StyledModerationMenu hash={hash} type={type} canDelete={canDelete} onHandleDelete={onHandleDelete} handleOnEditClick={handleOnEditClick}/>
                </>
            ) : null}
        </View>
    );
};
